export const studentsFormField = [
	{
		type: 'hidden',
		formControlName: 'b2bFlag',
	},
	{
		type: 'text',
		title: 'Username',
		placeholder: 'Enter Username',
		formControlName: 'username',
		required: true,
		maxLength: 100,
		errorsMsg: [
			{ type: 'required', message: 'Username is required' },
			{
				type: 'maxlength',
				message: 'Username should be less than 100 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Firstname',
		placeholder: 'Enter Firstname',
		formControlName: 'firstName',
		required: true,
		maxLength: 100,
		errorsMsg: [
			{ type: 'required', message: 'Firstname is required' },
			{
				type: 'maxlength',
				message: 'Firstname should be less than 100 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Lastname',
		placeholder: 'Enter Lastname',
		formControlName: 'lastName',
		required: true,
		maxLength: 100,
		errorsMsg: [
			{ type: 'required', message: 'Lastname is required' },
			{
				type: 'maxlength',
				message: 'Lastname should be less than 100 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Password',
		placeholder: 'Enter password',
		formControlName: 'password',
		required: true,
		maxLength: 50,
		minLength: 8,
		errorsMsg: [
			{ type: 'required', message: 'password is required' },
			{
				type: 'maxlength',
				message: 'password should be less than 50 characters',
			},
			{
				type: 'minlength',
				message: 'password should be greater than 8 characters',
			},
		],
	},
];
